import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CalendarioGestionForm from "./CalendarioGestionForm";
import { getData, pathData } from "../../Utils/Http/api";

const CalendarioGestionEdit = () => {
  const { id } = useParams();
  const [valores, setValores] = useState(null);
  const [noExiste, setNoExiste] = useState(false);

  // El listado es chico (una fila por gestor, día y organismo): se busca ahí la fila que se edita.
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getData("/CalendarioGestionListar");
        const fila = (res?.value || []).find((f) => f.idCalendarioGestion === Number(id));
        if (fila) setValores({ idUsuario: fila.idUsuario, idOrganismo: fila.idOrganismo, diaSemana: fila.diaSemana });
        else setNoExiste(true);
      } catch (ex) {
        console.error("Error cargando el Calendario de Gestores:", ex);
        setNoExiste(true);
      }
    };
    fetchData();
  }, [id]);

  // El formulario toma los valores iniciales una sola vez: se monta cuando la fila ya llegó.
  if (noExiste) return null;
  if (!valores) return null;

  return (
    <CalendarioGestionForm
      modo="edicion"
      titulo="Editar el Calendario de Gestores"
      descripcion="Cambiá el gestor, el día o el organismo de esta fila del calendario."
      valoresIniciales={valores}
      onGuardar={(datos) => pathData("/CalendarioGestionUpdate", { idCalendarioGestion: Number(id), ...datos })}
      mensajeExito="¡Calendario actualizado exitosamente!"
    />
  );
};

export default CalendarioGestionEdit;
